import Script from 'next/script';
import { FC } from 'react';
import {
  getEnvVariable,
  NEXT_PUBLIC_ENV,
  NEXT_PUBLIC_ENV_VARIANT
} from 'src/utils/envVariablesHelper';

// This component contains all 3rd-party analytics scripts
const AnalyticsScriptsLoader: FC = () => {
  const currentEnv = getEnvVariable(NEXT_PUBLIC_ENV);
  // Do not load tracking scripts for STAGE and DEV envs
  const noTracking =
    currentEnv === NEXT_PUBLIC_ENV_VARIANT.STAGE ||
    currentEnv === NEXT_PUBLIC_ENV_VARIANT.DEV;

  if (noTracking) {
    return null;
  }

  return (
    <>
      {/* Google Tag Manager */}
      <Script
        defer
        data-name="Google Tag Manager"
        data-nscript={false}
        dangerouslySetInnerHTML={{
          __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-5HRTCL5');`
        }}
      />
      {/* Google Analytics (gtag.js) */}
      <Script
        data-name="Google Analytics (gtag.js): script loading"
        src="https://www.googletagmanager.com/gtag/js?id=G-696M4VJDHS"
        defer
      />
      <Script
        data-name="Google Analytics (gtag.js): dataLayer initialization"
        id="google-analytics"
        defer
      >
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){window.dataLayer.push(arguments);}
          window.gtag = gtag;
          gtag('js', new Date());
          gtag('config', 'G-696M4VJDHS');
        `}
      </Script>
      {/* Plerdy Analytics Config */}
      <Script
        type="text/javascript"
        data-name="Plerdy Analytics Config"
        defer
        dangerouslySetInnerHTML={{
          __html: `var _protocol = (("https:" == document.location.protocol) ? "https://" : "http://");
             var _site_hash_code = "eabab8c5e5e6e183232816ef3d584104"
             var _suid = 25736`
        }}
      />
      {/* Meta Pixel Code */}
      <Script
        defer
        data-name="Meta Pixel Code"
        dangerouslySetInnerHTML={{
          __html: `!function(f,b,e,v,n,t,s)
              {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
              n.callMethod.apply(n,arguments):n.queue.push(arguments)};
              if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
              n.queue=[];t=b.createElement(e);t.async=!0;
              t.src=v;s=b.getElementsByTagName(e)[0];
              s.parentNode.insertBefore(t,s)}(window, document,'script',
              'https://connect.facebook.net/en_US/fbevents.js');
              fbq('init', '667280894834718');
              fbq('track', 'PageView');`
        }}
      />
    </>
  );
};

export default AnalyticsScriptsLoader;
